import {CameraIcon} from "../CameraIcon";
import React from "react";

export const HomeIdInput = ({technicalData, onChange, startBarcodeScanning}) => {

  const handleHomeIdChange = (event) => {
    onChange('home_id.value', event.target.value);
  }

  const handleScan = () => {
    startBarcodeScanning('home_id.value');
  }

  return (
      <div className="mt-3 p-2 rounded border border-gray-300"
           style={{backgroundColor: '#ECC792'}}>
        <div className="mb-2">
          <h5 className="text-xs font-bold text-gray-800 mb-1">Home-ID</h5>
        </div>
        <div>
          <div className="flex items-center space-x-2">
            <input
                type="text"
                value={technicalData?.home_id?.value || ''}
                onChange={handleHomeIdChange}
                className="flex-1 px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500"
                placeholder="Glasfaser-ID eingeben oder scannen"
            />
            <button
                type="button"
                onClick={handleScan}
                className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-md transition-colors"
                title="Barcode scannen"
            >
              <CameraIcon/>
            </button>
          </div>
        </div>
      </div>
  );
}